import { useCallback, useEffect, useState } from 'react'

const EXPERTS_CAROUSEL_VIEWPORT_THRESHOLD = 0.1

function getScrollParent(element: HTMLElement): Element | null {
  let parent = element.parentElement

  while (parent !== null) {
    const { overflowY } = window.getComputedStyle(parent)
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return parent
    }
    parent = parent.parentElement
  }

  return null
}

export function useInfiniteLandingExpertsCarouselInView(): {
  carouselRef: (node: HTMLDivElement | null) => void
  hasEnteredViewport: boolean
} {
  const [observeTarget, setObserveTarget] = useState<HTMLDivElement | null>(null)
  const [hasEnteredViewport, setHasEnteredViewport] = useState(false)

  const carouselRef = useCallback((node: HTMLDivElement | null) => {
    setObserveTarget(node)
  }, [])

  useEffect(() => {
    if (observeTarget === null || hasEnteredViewport) {
      return
    }

    const root = getScrollParent(observeTarget)

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries?.[0]?.isIntersecting) {
          setHasEnteredViewport(true)
          observer.disconnect()
        }
      },
      { root, threshold: EXPERTS_CAROUSEL_VIEWPORT_THRESHOLD }
    )

    observer.observe(observeTarget)

    return () => {
      observer.disconnect()
    }
  }, [observeTarget, hasEnteredViewport])

  return { carouselRef, hasEnteredViewport }
}
